import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function Addevent({ setOpenEvent, updateSimulation }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(true)
  const [duree, setDuree] = useState(false)

  const [yearsSet, setYearsSet] = useState(null)
  const [checkBox, setCheckBox] = useState({ val: '' })
  const [pEvents, setPEvents] = useState([])

  const { handleSubmit, reset, setValue, control } = useForm({})

  useEffect(() => {
    getPredefinedEvents()
    const years1 = Array.from({ length: 0 }, (_, index) => new Date().getFullYear() - 1 - index)
    const years2 = Array.from({ length: 30 }, (_, index) => new Date().getFullYear() + index)

    let year_list = [...years1.reverse(), ...years2]

    let final_year_list = []
    year_list.forEach((e, index) => final_year_list.push({ id: index, label: String(e) }))

    setYearsSet(final_year_list)
  }, [])

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setOpenEvent(false)
    reset()
    updateSimulation()
  }
  const getPredefinedEvents = async () => {
    const url = urls.getPredefinedEvents
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      let Types = []
      data.forEach((v) => {
        Types.push({ label: `${v.Nom}`, id: v.id })
      })
      setPEvents(Types)
    }
  }
  const onSubmitf = async (data) => {
    const payload = {
      ...data,
      Nom: data.Nom.label,
      AnneeDebut: data.AnneeDebut.label + '-01-01',

      OneShot: checkBox.val === 'n' ? true : false,
      PlusieursAnnee: checkBox.val === 'p' ? true : false,
    }

    const response = await makePostRequest(urls.CustomEventSimulation, payload, {}, true)
    if (response.status === 201) {
      handleClose()
    }
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        className="no-drag"
        PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden', bgcolor: '#f7fbff' } }}
      >
        <DialogTitle sx={{ color: '#10233f !important', bgcolor: '#ffffff', px: 3, py: 2.4 }}>
          {t('monPatrimoine.addEventDialogTitle')}
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmitf)} name="newfa">
          <DialogContent sx={{ px: 3, py: 2.5 }}>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('Nom', j)}
              label={t('monPatrimoine.eventLabel')}
              data={pEvents}
              name="Nom"
              required={true}
              sx={{ width: '100%', mt: 0 }}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'number',
              }}
              rules={{ required: true }}
              name="ValeurInitial"
              label={t('monPatrimoine.valueLabel')}
            />{' '}
            <ComboBox
              handleAutoComplete={(e, j) => setValue('AnneeDebut', j)}
              label={t('monPatrimoine.yearLabel')}
              data={yearsSet}
              name="AnneeDebut"
              required={true}
              sx={{ width: '100%' }}
            />
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                sx={{ ml: 2 }}
                name="check-box"
                control={control}
                onChange={(e) => {
                  setCheckBox({ val: e.target.value })
                  if (e.target.value === 'p') {
                    setDuree(true)
                  } else {
                    setDuree(false)
                  }
                }}
              >
                <FormControlLabel value="n" control={<Radio />} label={t('monPatrimoine.oneShot')} required />
                <FormControlLabel value="p" control={<Radio />} label={t('monPatrimoine.multipleYears')} required />
              </RadioGroup>
            </FormControl>
            {duree && (
              <Input
                control={control}
                inputProps={{
                  variant: 'outlined',
                  required: true,
                  size: 'small',
                  type: 'number',
                }}
                rules={{ required: true }}
                name="Duree"
                label={t('monPatrimoine.duration')}
              />
            )}
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'number',
              }}
              rules={{ required: true }}
              name="CoutAnnuel"
              label={t('monPatrimoine.annualCost')}
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, bgcolor: '#ffffff', borderTop: '1px solid rgba(20, 104, 183, 0.1)' }}>
            <Button variant="contained" type="submit" sx={{ borderRadius: 999, textTransform: 'none', fontWeight: 850 }}>
              {t('monPatrimoine.validate')}
            </Button>
            <Button onClick={handleClose} sx={{ borderRadius: 999, textTransform: 'none', fontWeight: 850 }}>
              {t('monPatrimoine.cancel')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
